var _path, _path2, _g, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61mm",
    height: "13mm",
    viewBox: "0 0 61 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-45,-50)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m56 60-6 4-6-4v-6l6-4 6 4z",
    fill: "#320e40",
    strokeWidth: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m55 60-5 3-5-3v-6l5-3 5 3z",
    strokeWidth: 0.04
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#320e40"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.04
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 58,
    width: 0.66,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 58,
    width: 0.66,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 56,
    width: 0.66,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 56,
    width: 0.66,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 54,
    width: 0.66,
    height: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 54,
    width: 0.66,
    height: 0.95
  })), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-.57)",
    x: 47,
    y: 60,
    width: 4.8,
    height: 0.55,
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 60,
    width: 0.66,
    height: 0.95,
    strokeWidth: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 60,
    width: 0.66,
    height: 0.95,
    strokeWidth: 0.04
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.05
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-.57)",
    x: 47,
    y: 58,
    width: 4.8,
    height: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-.6)",
    x: 47,
    y: 56,
    width: 4.8,
    height: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-.6)",
    x: 47,
    y: 54,
    width: 4.8,
    height: 0.56
  })))), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 63,
    fill: "#000000",
    fontFamily: "Garuda",
    fontSize: "16.51px",
    letterSpacing: "0px",
    strokeWidth: 1.05,
    wordSpacing: "0px",
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 56,
    y: 63,
    fontFamily: "monospace",
    strokeWidth: 1.05
  }, "stack")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.826f7908b0d840f1aed5f7839ccc958f.svg";
export { ForwardRef as ReactComponent };